import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";
import {
  Box,
  Button,
  Grid,
  TextField,
  Typography,
  FormControl,
  Tabs,
  Tab,
  Paper,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { TextareaAutosize, makeStyles } from "@material-ui/core";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import "ag-grid-community/dist/styles/ag-grid.css";
import { KRATable as tableDef } from "../../config/grid-columns-defs";
import { getKraDataList, insertKraData } from "../../api/KRAapis";
import { showAlert } from "../../actions/alert";
import { handleAxiosError } from "../../config/action-config";
import TabPanel from "../../component/TabPanel";
import CustomLargeTextCellEditor from "../../component/CustomLargeCellEditor";
import {
  getLatestStatusbyId,
  getMeetingDetailsbyId,
  getemployeeAppraisaldatabyId,
  setMyAppraisal,
} from "../../api/appraisal";
import SkipNextIcon from "@mui/icons-material/SkipNext";

const useStyles = makeStyles((theme) => ({
  textfeild: {
    "& .MuiFilledInput-root": {
      color: "#fff !important",
    },
  },
}));
export default function KraList() {
  const containerStyle = useMemo(() => ({ width: "100%", height: "100%" }), []);
  const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);
  const classes = useStyles();
  const location = useLocation();
  const [eId, setEId] = useState("");
  const [latestStatus, setLatestStatus] = useState([{}]);
  const [meetingData, setMeetingData] = useState({});
  const gridApiRef = useRef();
  const gridApiRefForNonStock = useRef();
  const [goalData, setGoalData] = useState([]);
  const [isQtyEmpty, setIsQtyEmpty] = useState(false);
  const [QtyEmpty, setQtyEmpty] = useState(false);
  const [kpiData, setKPIData] = useState([]);
  const user = useSelector((state) => state.user);
  const [loading, setLoading] = useState(false);
  const [loader, setLoader] = useState(false);
  const [rowData, setRowData] = useState([]);
  const dispatch = useDispatch();
  const params = useParams();
  const navigate = useNavigate();
  const [tabIndex, setTabIndex] = useState(0);
  const [save, setSave] = useState(false);
  const [rating, setRating] = useState([
    { employee_rating: 1 },
    { employee_rating: 1.5 },
    { employee_rating: 2 },
    { employee_rating: 2.5 },
    { employee_rating: 3 },
    { employee_rating: 3.5 },
    { employee_rating: 4 },
    { employee_rating: 4.5 },
    { employee_rating: 5 },
  ]);

  useEffect(() => {
    getEmployeeData();
    getStatus();
  }, []);
  const [open, setOpen] = useState(false);

  const [tableRefreshCount, setTableRefreshCount] = useState(0);
  function refreshTable() {
    setTableRefreshCount((prev) => prev + 1);
  }
  async function getKraData() {
    let date = new Date();
    let year = date.getFullYear();
    // console.log(year,"year")
    try {
      const { data } = await getKraDataList(
        {
          role: user.role,
          department: user.department,
          year: year,
          is_kpi: "",
        },
        user.token
      );

      setRowData([...data.KraList]);
      let goal = data.KraList.filter((e) => e.is_kpi === false);
      let kpi = data.KraList.filter((e) => e.is_kpi === true);
      setGoalData(goal);
      setKPIData(kpi);
    } catch (error) {
      handleAxiosError(error, dispatch);
      return { error: true };
    }
  }

  const onCellValueChanged = async (params) => {
    const updatedRowData = [...goalData];
    const rowIndex = params.rowIndex;
    updatedRowData[rowIndex] = params.data;
    // console.log(updatedRowData, "updatedRowData");
    setGoalData(updatedRowData);
  };
  const onCellValueChangedkpi = async (params) => {
    const updatedRowData = [...kpiData];
    const rowIndex = params.rowIndex;
    updatedRowData[rowIndex] = params.data;
    // console.log(updatedRowData, "updatedRowData");
    setKPIData(updatedRowData);
  };

  // console.log(rowData,"rowdata")
  // const onSubmit = async (event) => {
  //   event.preventDefault();
  //   try {
  //     const { data } = await setMyAppraisal({KraData:[rowData]}, user.token);
  //     dispatch(showAlert(data.msg));
  //   } catch (error) {
  //     handleAxiosError(error, dispatch);
  //   }
  // };

  useEffect(() => {
    getMeetingDetail();
  }, [tabIndex === 2]);
  async function getMeetingDetail() {
    try {
      const { data } = await getMeetingDetailsbyId(
        user.appraisal_id,
        user.token
      );
      setMeetingData(data.data);
    } catch (err) {
      handleAxiosError(err);
      return { error: true };
    }
  }

  const defaultColDef = useMemo(() => {
    return {
      flex: 1,
    };
  }, []);

  async function getStatus() {
    try {
      const { data } = await getLatestStatusbyId(user.appraisal_id, user.token);
      setLatestStatus(data.data);
    } catch (err) {
      handleAxiosError(err);
      return { error: true };
    }
  }
  console.log(meetingData, "mdmd");
  // console.log(latestStatus,"latest")
  async function getEmployeeData() {
    try {
      const { data } = await getemployeeAppraisaldatabyId(
        user.appraisal_id,
        user.token
      );
      if (data?.totalCount !== 0) {
        setRowData([...data.KraDetails]);
        let goal = data.KraDetails.filter((e) => e.is_kpi === false);
        let kpi = data.KraDetails.filter((e) => e.is_kpi === true);
        setGoalData(goal);
        setKPIData(kpi);
      } else {
        getKraData();
      }
    } catch (error) {
      handleAxiosError(error);
      return { error: true };
    } finally {
    }
  }
  const CheckData = () => {
    if (gridApiRef?.current) {
      const editingCell = gridApiRef.current.getEditingCells()[0];
      if (editingCell) {
        gridApiRef.current.stopEditing();
      }
    }

    const EmptyKpiCell = kpiData.some(
      (item) =>
        item.employee_remarks === "" ||
        item.employee_remarks === null ||
        item.employee_remarks === undefined ||
        item.employee_rating === "" ||
        item.employee_rating === null ||
        item.employee_rating === undefined
    );
    if (EmptyKpiCell) {
      setQtyEmpty(EmptyKpiCell);
      dispatch(showAlert("please fill all the fields"));
      return;
    } else {
      setSave(true);
    }
  };
  const onSubmit = async (event) => {
    setSave(false);
    const extractedFields = extractEmpKra([...kpiData, ...goalData]);
    try {
      const { data } = await setMyAppraisal(
        { KraData: extractedFields },
        user.token
      );
      dispatch(showAlert(data.msg));
      setSave(false);
      getStatus();
      refreshTable();
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  };
  const extractEmpKra = (empkRaData) => {
    return empkRaData.map((item, index) => ({
      kra_id: item.id.toString(),
      appraisal_id: user.appraisal_id.toString(),
      employee_rating: item.employee_rating.toString(),
      employee_remarks: item.employee_remarks,
    }));
  };

  const nextfunc = () => {
    if (gridApiRef?.current) {
      const editingCell = gridApiRef.current.getEditingCells()[0];
      if (editingCell) {
        gridApiRef.current.stopEditing();
      }
    }

    const EmptyCell = goalData.some(
      (item) =>
        item.employee_remarks === "" ||
        item.employee_remarks === null ||
        item.employee_remarks === undefined ||
        item.employee_rating === "" ||
        item.employee_rating === null ||
        item.employee_rating === undefined
    );

    if (EmptyCell) {
      setIsQtyEmpty(EmptyCell);
      dispatch(showAlert("please fill all the fields"));
      return;
    } else {
      setTabIndex(1);
    }
  };
  console.log(
    latestStatus[0].appraisal_status,
    "latestStatus[0].appraisal_status"
  );
  return (
    <Box className="pmt-container-box">
      <Box className="pmt-title-box ">
        <Box className="typography-title">
          <Typography variant="h1" className="pmt-headings-h1">
            Appraisal Detail
          </Typography>
        </Box>
        <Grid
          sx={{ display: "flex", justifyContent: "end", gap: 2 }}
          item
          lg={4}
          md={4}
          sm={2}
          xs={2}
        >
          {latestStatus[0].appraisal_status === "Initiated" &&
            tabIndex === 1 && (
              <Button
                size="medium"
                sx={{ borderRadius: "15px", fontWeight: "bold" }}
                variant="contained"
                color="info"
                onClick={() => CheckData()}
              >
                Submit
              </Button>
            )}
        </Grid>
      </Box>
      <br />

      <Box sx={{ borderBottom: 1, width: "100%", borderColor: "divider" }}>
        <Tabs
          value={tabIndex}
          onChange={(e, nv) => {
            setTabIndex(nv);
          }}
          aria-label="basic tabs example"
        >
          <Tab
            label="Goals"
            id="simple-tab-0"
            aria-controls="simple-tabpanel-0"
            style={{ paddingLeft: 10, paddingRight: 10 }}
          />
          <Tab
            label="KPI"
            id="simple-tab-1"
            aria-controls="simple-tabpanel-1"
            style={{ paddingLeft: 10, paddingRight: 10 }}
          />
          {(latestStatus[0].appraisal_status === "Meeting_Scheduled" ||
            latestStatus[0].appraisal_status === "Appraisal_Completed") && (
              <Tab
                label="Meeting Detail"
                id="simple-tab-2"
                aria-controls="simple-tabpanel-2"
                style={{ paddingLeft: 10, paddingRight: 10 }}
              />
            )}
        </Tabs>
      </Box>
      <TabPanel value={tabIndex} index={0}>
        <Paper>
          <div style={{ height: "450px" }}>
            <div style={gridStyle} className="ag-theme-alpine">
              <AgGridReact
                columnDefs={[
                  {
                    headerName: "Goal",
                    field: "kpi_goal",
                    minWidth: 750,
                    maxWidth: 800,
                    resizable: true,
                    wrapText: true,
                    autoHeight: true,
                  },
                  {
                    headerName: "Remarks",
                    field: "employee_remarks",
                    minWidth: 200,
                    maxWidth: 400,
                    resizable: true,
                    autoHeight: true,
                    wrapText: true,
                    cellEditor: CustomLargeTextCellEditor,
                    cellEditorPopup: true,
                    editable: true,
                    cellRenderer: (params) => (
                      <>
                        {!params?.data?.employee_remarks &&
                        params?.data?.employee_remarks !== 0 &&
                        isQtyEmpty ? (
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              gap: "3px",
                            }}
                            className="mandatory-cell"
                          >
                            <p
                              style={{
                                color: "red",
                                fontSize: "10px",
                                fontWeight: "bold",
                              }}
                            >
                              *this Field is mandatory
                            </p>
                          </Box>
                        ) : (
                          <Box sx={{ display: "flex", gap: "3px" }}>
                            <p>{params?.data?.employee_remarks}</p>
                          </Box>
                        )}
                      </>
                    ),
                    cellEditorParams: {
                      rows: 20,
                      cols: 50,
                    },
                  },
                  {
                    headerName: "Rating",
                    field: "employee_rating",
                    minWidth: 30,
                    maxWidth: 100,
                    resizable: true,
                    autoHeight: true,
                    editable: true,
                    cellEditor: "agSelectCellEditor",
                    cellRenderer: (params) => (
                      <>
                        {!params?.data?.employee_rating &&
                        params?.data?.employee_rating !== 0 &&
                        isQtyEmpty ? (
                          <Box
                            sx={{ display: "flex", gap: "3px" }}
                            className="mandatory-cell"
                          >
                            <p
                              style={{
                                color: "red",
                                fontSize: "10px",
                                fontWeight: "bold",
                              }}
                            >
                              *this Field is mandatory
                            </p>
                          </Box>
                        ) : (
                          <Box sx={{ display: "flex", gap: "3px" }}>
                            <p style={{ color: "#000" }}>
                              {params?.data?.employee_rating}
                            </p>
                          </Box>
                        )}
                      </>
                    ),
                    cellEditorParams: {
                      values: [
                        ...new Set(rating.map((emp) => emp.employee_rating)),
                      ],
                    },
                  },
                ]}
                rowData={goalData}
                onCellValueChanged={onCellValueChanged}
                defaultColDef={defaultColDef}
              />
            </div>
          </div>
        </Paper>
        <div style={{ display: "flex", justifyContent: "end", gap: 2 }}>
          {latestStatus[0].appraisal_status === "Initiated" && (
            <Button
              size="large"
              sx={{ marginTop: 2, borderRadius: "15px", fontWeight: "bold" }}
              variant="contained"
              color="info"
              onClick={() => nextfunc()}
            >
              Next
              <SkipNextIcon />
            </Button>
          )}
        </div>
      </TabPanel>

      <TabPanel value={tabIndex} index={1}>
        <Paper>
          <div style={{ height: "450px" }}>
            <div style={gridStyle} className={"ag-theme-alpine"}>
              <AgGridReact
                columnDefs={[
                  {
                    headerName: "Goal",
                    field: "kpi_goal",
                    resizable: true,
                    wrapText: true,
                    autoHeight: true,
                  },
                  {
                    headerName: "Remarks",
                    field: "employee_remarks",
                    minWidth: 50,
                    maxWidth: 350,
                    resizable: true,
                    autoHeight: true,
                    wrapText: true,
                    cellEditor: CustomLargeTextCellEditor,
                    cellEditorPopup: true,
                    editable: true,
                    cellRenderer: (params) => (
                      <>
                        {!params?.data?.employee_remarks &&
                        params?.data?.employee_remarks !== 0 &&
                        QtyEmpty ? (
                          <Box
                            sx={{ display: "flex", gap: "3px" }}
                            className="mandatory-cell"
                          >
                            <p
                              style={{
                                color: "red",
                                fontSize: "10px",
                                fontWeight: "bold",
                              }}
                            >
                              *this Field is mandatory
                            </p>
                          </Box>
                        ) : (
                          <Box sx={{ display: "flex", gap: "3px" }}>
                            <p style={{ color: "#000" }}>
                              {params?.data?.employee_remarks}
                            </p>
                          </Box>
                        )}
                      </>
                    ),
                    cellEditorParams: {
                      rows: 20,
                      cols: 50,
                    },
                  },
                  {
                    headerName: "Rating",
                    field: "employee_rating",
                    minWidth: 30,
                    maxWidth: 100,
                    resizable: true,
                    autoHeight: true,
                    editable: true,
                    cellEditor: "agSelectCellEditor",
                    cellRenderer: (params) => (
                      <>
                        {!params?.data?.employee_rating &&
                        params?.data?.employee_rating !== 0 &&
                        QtyEmpty ? (
                          <Box
                            sx={{ display: "flex", gap: "3px" }}
                            className="mandatory-cell"
                          >
                            <p
                              style={{
                                color: "red",
                                fontSize: "10px",
                                fontWeight: "bold",
                              }}
                            >
                              *this Field is mandatory
                            </p>
                          </Box>
                        ) : (
                          <Box sx={{ display: "flex", gap: "3px" }}>
                            <p style={{ color: "#000" }}>
                              {params?.data?.employee_rating}
                            </p>
                          </Box>
                        )}
                      </>
                    ),
                    cellEditorParams: {
                      values: [
                        ...new Set(rating.map((emp) => emp.employee_rating)),
                      ],
                    },
                  },
                ]}
                rowData={kpiData}
                onCellValueChanged={onCellValueChangedkpi}
                defaultColDef={defaultColDef}
              />
            </div>
          </div>
        </Paper>
      </TabPanel>
      <TabPanel value={tabIndex} index={2}>
        <Paper elevation={5} sx={{ display: "flex", justifyContent: "center" }}>
          <div style={{ height: "450px", width: "800px" }}>
            <Grid item xs={12} md={6} sm={6} sx={{ m: "10px" }}>
              <Box className="typography-title">
                <Typography variant="h1" className="appraisal-heading-h1">
                  Meeting Scheduled
                </Typography>
              </Box>
            </Grid>
            <Grid
              container
              spacing={3}
              className=""
              sx={{ display: "flex", justifyContent: "center", m: 2, mb: 2 }}
            >
              <Grid item xs={10} md={5} sm={5}>
                <TextField
                  name="meeting_tittle"
                  fullWidth
                  label="Meeting Tittle "
                  value={meetingData[0]?.subject || ""}
                  type="text"
                  disabled
                  required
                />
              </Grid>
              <Grid item xs={10} md={5} sm={5}>
                <TextField
                  name="employee_name"
                  fullWidth
                  label="Attendees"
                  type="text"
                  color="secondary"
                  value={meetingData[0]?.attendees || ""}
                  disabled
                  required
                />
              </Grid>

              <Grid item xs={10} md={10} sm={10}>
                <TextField
                  name="start_time"
                  fullWidth
                  label="Meeting Start On"
                  value={formatDateTime(meetingData[0]?.meeting_start) || ""}
                  required
                  disabled
                  type="text"
                />
              </Grid>

              <Grid item xs={10} md={10} sm={10}>
                <TextField
                  name="end_time"
                  fullWidth
                  label="Meeting End On "
                  value={formatDateTime(meetingData[0]?.meeting_end) || ""}
                  type="text"
                  disabled
                  required
                />
              </Grid>
              <Grid item xs={10} md={5} sm={5}></Grid>
              <Grid item xs={10} md={5} sm={5}></Grid>
            </Grid>
            <Box
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "20px",
                margin: "14px",
              }}
            >
             { latestStatus[0].appraisal_status !== "Appraisal_Completed" && 
             <Button
                size="Large"
                sx={{
                  borderRadius: "10px",
                  fontWeight: "bold",
                  fontSize: "14px",
                }}
                variant="contained"
                color="primary"
              >
                <a href={meetingData[0]?.meeting_url}>Join Meeting</a>
              </Button>}
            </Box>
          </div>
        </Paper>
      </TabPanel>
      <Dialog
        open={save}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <>
          <DialogTitle id="alert-dialog-title">Confirm Save</DialogTitle>
          <DialogContent style={{ width: "500px" }}>
            <DialogContentText id="alert-dialog-description">
              <p>Are you sure you want to Save?</p>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              size="medium"
              onClick={() => {
                setSave(false);
              }}
              variant="contained"
              color="inherit"
            >
              Cancel
            </Button>
            <Button
              size="medium"
              onClick={() => {
                onSubmit();
              }}
              variant="contained"
              color="info"
            >
              Confirm
            </Button>
          </DialogActions>
        </>
      </Dialog>
    </Box>
  );
}

const formatDateTime = (isoString) => {
  if (!isoString) return "";
  const date = new Date(isoString);
  const options = {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
    timeZone: "UTC",
  };
  return date.toLocaleString("en-GB", options).replace(",", "");
};
